import Vue from 'vue'
import VueClipBoard from 'vue-clipboard2'
import Pagination from '~/components/common/Pagination'

Vue.component('Pagination', Pagination)

VueClipBoard.config.autoSetContainer = true
Vue.use(VueClipBoard)

// EventBus 생성
// SSR에서는 요청 간 리스너 누적을 방지하기 위해 no-op 처리.
// 실제 $EventBus 사용은 모두 클라이언트 사이드(mounted/beforeMount)에서만 발생.
if (process.client) {
  Vue.prototype.$EventBus = new Vue()
} else {
  // SSR: $on/$off/$emit 호출이 있어도 누적되지 않도록 no-op shim
  Vue.prototype.$EventBus = {
    $on () {},
    $off () {},
    $once () {},
    $emit () {}
  }
}
